const RESERVED_TENANT_HOSTS = new Set(['www', 'api', 'admin', 'service']);
const PLATFORM_ROOT_HOSTS = new Set([
  'playemp.vip',
  'www.playemp.vip',
  'service.playemp.vip',
  'localhost',
  '127.0.0.1',
  '0.0.0.0',
]);
const RESERVED_ROOT_SEGMENTS = new Set([
  'auth', 'admin', 'app', 'api', 'icons', 'static', 'staff', 'preview',
  'staff-portal', 'finance', 'deposit-return', 'portal', 'uploads',
]);

function isCustomTenantHost(host) {
  if (!host || PLATFORM_ROOT_HOSTS.has(host)) return false;
  if (/^\d{1,3}(?:\.\d{1,3}){3}$/.test(host)) return false;
  if (host.endsWith('.local')) return false;
  return host.includes('.');
}

export function tenantSlugFromHost(hostname = window.location.hostname) {
  const host = String(hostname || '').split(':')[0].trim().toLowerCase().replace(/\.$/, '');
  if (!host) return null;

  const parts = host.split('.').filter(Boolean);
  if (parts.length >= 3 && parts.slice(-2).join('.') === 'playemp.vip') {
    const subdomain = parts[0].toLowerCase();
    if (!RESERVED_TENANT_HOSTS.has(subdomain)) return subdomain;
  }
  if (isCustomTenantHost(host)) return host;
  return null;
}

export function tenantSlugFromPathOrHost(
  pathname = window.location.pathname,
  hostname = window.location.hostname,
) {
  const parts = String(pathname || '').split('/').filter(Boolean);
  if (parts.length > 0) {
    const first = parts[0].toLowerCase();
    if (!RESERVED_ROOT_SEGMENTS.has(first)) return first;
  }
  return tenantSlugFromHost(hostname);
}
